<code-input
  #codeInput
  [code]="pinForm.value"
  [isCodeHidden]="false"
  [codeLength]="NUMBER_OF_PIN_DIGIT"
  [disabled]="disabled"
  (codeChanged)="onPinCodeChanged($event)"
>
</code-input>
